// fetchCountries.js
import { message } from "antd";
import { token } from "../../constants/Constants";
import { fetch_all_family_member_types } from "../../endpoints/API";

export const fetchFamilyMemberType = async (
  setIsFamilyMemberType,
  baseUrl,
  prodTestUrl
) => {
  try {
    const response = await fetch_all_family_member_types();
    if (response.statusText=="OK") {
      const data = response?.data;
      setIsFamilyMemberType(data);
    } else {
      message.error("Failed to fetch family member types.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching family member types.");
  }
};
